(() => {
  const form = document.querySelector('[data-ch-cart-form]');
  if (form) {
    const status = form.querySelector('[data-cart-page-status]');
    let busy = false;
    const setBusy = value => {
      busy = value;
      form.setAttribute('aria-busy', String(value));
      form.querySelectorAll('button, input, textarea').forEach(el => { el.disabled = value; });
      form.querySelectorAll('[data-ch-wallets]').forEach(el => { el.inert = value; });
    };
    const showError = error => {
      setBusy(false);
      status.textContent = error.message || 'Your cart could not be updated. Please try again.';
      status.hidden = false;
    };
    const cartUrl = JSON.parse(document.getElementById('ch-cart-config').textContent).root + 'cart';
    window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
    // Capture before third-party cart handlers; each action keeps the exact item key.
    window.addEventListener('click', async event => {
      const checkout = event.target.closest('.cart-summary__checkout');
      if (checkout && form.contains(checkout)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!busy) form.requestSubmit(checkout);
        return;
      }
      const button = event.target.closest('[data-cart-remove]');
      if (!button || !form.contains(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      setBusy(true);
      try { await window.CHCartState.change(button.dataset.cartRemove, 0); window.location.assign(cartUrl); }
      catch (error) { showError(error); }
    }, true);
    window.addEventListener('submit', async event => {
      if (event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const updates = {};
      for (const input of form.querySelectorAll('[data-cart-quantity]')) {
        if (!input.checkValidity()) { input.reportValidity(); return; }
        updates[input.closest('[data-cart-key]').dataset.cartKey] = Number(input.value);
      }
      const note = form.querySelector('[name="note"]').value;
      const goingToCheckout = event.submitter?.name === 'checkout';
      setBusy(true);
      try {
        await window.CHCartState.update(updates, note);
        window.location.href = goingToCheckout ? cartUrl.replace(/cart$/, 'checkout') : cartUrl;
      } catch (error) { showError(error); }
    }, true);
    const rendered = [...form.querySelectorAll('[data-cart-key]')].map(el =>
      [el.dataset.cartKey, Number(el.querySelector('[data-cart-quantity]').value), Number(el.dataset.cartFinal)]);
    setBusy(true);
    window.CHCartState.refresh().then(cart => {
      const current = cart.items.map(i => [i.key, i.quantity, i.final_line_price]);
      if (JSON.stringify(rendered) !== JSON.stringify(current)) window.location.replace(cartUrl);
      else { setBusy(false); if (cart.ch_notice) showError({message: cart.ch_notice}); }
    }).catch(showError);
  }

  // Commslayer uses inline !important offsets, so preserve and restore those values.
  const savedOffsets = new WeakMap();
  const watchedWidgets = new WeakSet();
  const sticky = document.querySelector('sticky-add-to-cart');
  function positionChat() {
    const raised = !!sticky?.classList.contains('is-visible') && window.innerWidth <= 900;
    const reserve = raised ? Math.ceil(sticky.getBoundingClientRect().height) + 24 : 0;
    document.body.classList.toggle('ch-purchase-bar-visible', raised);
    document.querySelectorAll('.woot-widget-bubble, .woot-widget-holder').forEach(el => {
      if (!watchedWidgets.has(el)) {
        watchedWidgets.add(el);
        new MutationObserver(positionChat).observe(el, {attributes: true, attributeFilter: ['style']});
      }
      if (raised) {
        if (!savedOffsets.has(el)) savedOffsets.set(el, {value: el.style.getPropertyValue('bottom'), priority: el.style.getPropertyPriority('bottom')});
        const offset = (reserve + (el.classList.contains('woot-widget-holder') ? 84 : 0)) + 'px';
        if (el.style.getPropertyValue('bottom') !== offset || el.style.getPropertyPriority('bottom') !== 'important') el.style.setProperty('bottom', offset, 'important');
      } else if (savedOffsets.has(el)) {
        const previous = savedOffsets.get(el);
        if (previous.value) el.style.setProperty('bottom', previous.value, previous.priority);
        else el.style.removeProperty('bottom');
        savedOffsets.delete(el);
      }
    });
  }
  if (sticky) new MutationObserver(positionChat).observe(sticky, {attributes: true, attributeFilter: ['class']});
  new MutationObserver(mutations => {
    if (mutations.some(m => [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches('.woot-widget-bubble, .woot-widget-holder') || n.querySelector('.woot-widget-bubble, .woot-widget-holder'))))) positionChat();
  }).observe(document.body, {childList: true, subtree: true});
  window.addEventListener('resize', positionChat, {passive: true});
  positionChat();
})();
